import { storageGetItem, storageSetItem } from '@/utils/utils';
import { baseUrlApis } from 'Api/index';
import { store } from 'Store/index';
import { boxConfig, dropBoxConfig, googleDriveConfig, oneDriveConfig } from './apps.config';

const domainForDeveloper = [
  'http://localhost:3000/',
  'https://localhost:11443/',
  'https://online-fzk8s.connectedpdf.com/',
  'https://online-demo4.connectedpdf.com/',
  'https://pdfonline-demo4.connectedpdf.com/',
  'https://pdfonline-fzk8s.connectedpdf.com/',
  'https://pdfonline-azk8s.connectedpdf.com/',
  'https://online-azk8s.foxit.com/',
  'https://online-azk8s.foxitcloud.com/',
  'https://pdfonline-azk8s.foxitcloud.com/',
  'https://onlinebuild02-azk8s.connectedpdf.com/',
  'https://pdfonline-euazk8s.connectedpdf.com/',
  'https://pdfonline-caazk8s.connectedpdf.com/',
  'https://feature-drives.online-azk8s.foxitcloud.com/',
  'https://online-azk8s.connectedpdf.com/',
];
const domainForDeploy = [
  // 生产环境
  'https://pdfonline.foxit.com/',
  'https://pdfonline.foxit.co.jp/',
  'https://pdfonline.foxitsoftware.com/',
  'https://pdfonline-eu1.foxit.com/',
  'https://pdfonline-na2.foxit.com/',

  // 预发布环境
  'https://pdfonline-stgus.connectedpdf.com/',
  'https://pdfonline-stgeu.connectedpdf.com/',
  'https://pdfonline-stgca.connectedpdf.com/',
]
export const GOOGLE_DRIVE = 'Google Drive';
export const ONE_DRIVE = 'OneDrive';
export const DROP_BOX = 'DropBox';
export const BOX = 'Box';
export const iManage = 'iManage';
export const RECENT_BOX = 'RecentFiles';
export const DOCUMENT_BOX = 'Documents';
export const FOXIT_STORAGE = 'FoxitStorage';
export const IMANAGE_API = {
  iManageHost: "https://cloudimanage.com",
}
export const IMANAGE_CONFIG = {
  CLIENT_ID: 'b5595267-5cac-4256-867c-5a8a8a13aa70',
  CLIENT_SECRET: '4e262296-8041-483e-bf2f-d20d3bbbcf70',
}
export const GOOGLE_DRIVE_API = {
  BASEURL: 'https://www.googleapis.com',
  DOWNLOAD_FILE: '/drive/v3/files',
  EXPORT_FILE: '/drive/v3/files',
  GET_USER_INFO: '/drive/v3/about',
  GET_FILES: '/drive/v3/files',
  UPDATE_FILE: '/upload/drive/v3/files',
  CREATE_FILE: '/upload/drive/v3/files',
  CREATE_FOLDER: '/drive/v3/files',
  LIST_FOLDER: '/drive/v3/files',
  LIST_FILES: '/drive/v3/files',
  GET_ACCESS_TOKEN: 'https://oauth2.googleapis.com/token',
  REVOKE_ACCESS_TOKEN: 'https://oauth2.googleapis.com/revoke',
};
export const GOOGLE_DRIVE_CONFIG = {
  // Client ID and API key from the Developer Console
  CLIENT_ID: '',
  CLIENT_SECRET: '',
  API_KEY: '',
  SET_APP_CONFIG: function () {
    let redirectUrl = baseUrlApis.getBaseUrl();

    if (domainForDeveloper.indexOf(redirectUrl) > -1) {
      const devConfig = googleDriveConfig.dev

      this.CLIENT_ID = devConfig.CLIENT_ID;
      this.API_KEY = devConfig.API_KEY;
      this.CLIENT_SECRET = devConfig.CLIENT_SECRET;
    }
    if (domainForDeploy.indexOf(redirectUrl) > -1) {
      const proConfig = googleDriveConfig.pro

      this.CLIENT_ID = proConfig.CLIENT_ID;
      this.API_KEY = proConfig.API_KEY;
      this.CLIENT_SECRET = proConfig.CLIENT_SECRET;
    }
  },
  AUTHORIZATION_URL: function (fileParams) {
    let redirectUrl = baseUrlApis.getBaseUrl();
    const language = store.appStore.lng.full;

    // todo 部署后，没有获取到refresh token
    if (fileParams) {
      // prompt=select_account
      return `https://accounts.google.com/o/oauth2/v2/auth?prompt=consent&response_type=code&access_type=offline&client_id=${this.CLIENT_ID}&scope=https://www.googleapis.com/auth/drive&hl=${language}&redirect_uri=${redirectUrl}GoogleDriveAuthrizationWin.html&state=${fileParams}`;
    } else {
      return `https://accounts.google.com/o/oauth2/v2/auth?prompt=consent&response_type=code&access_type=offline&client_id=${this.CLIENT_ID}&scope=https://www.googleapis.com/auth/drive&hl=${language}&redirect_uri=${redirectUrl}GoogleDriveAuthrizationWin.html`;
    }
  },
  // Array of API discovery doc URLs for APIs used by the quickstart
  DISCOVERY_DOCS: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],

  // Authorization scopes required by the API; multiple scopes can be
  // included, separated by spaces.
  // SCOPES: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.metadata.readonly',
  SCOPES: 'https://www.googleapis.com/auth/drive',
};

export const ONE_DRIVE_API = {
  BASEURL: 'https://graph.microsoft.com/v1.0',
  GET_USER_INFO: '/me',
  GET_ROOT_FILES: '/me/drive/root/children',
  GET_FILES: '/me/drive/items',
  UPDATE_FILE: '/me/drive/items',
  CREATE_FILE: '/me/drive/items',
  GET_ACCESS_TOKEN: 'https://login.live.com/oauth20_token.srf',
  UPLOAD_FILE_TO_SHAREPOINT: function({fileName, path}) {
    return `${path}/${fileName}:/createUploadSession`
  }
};
export const ONE_DRIVE_CONFIG = {
  APP_ID: '',
  CLIENT_SECRET: '',
  CLIENT_ID: '',
  SCOPES: ['user.read', 'Files.ReadWrite.All'],
  INIT_CONFIG: function () {
    let redirectUrl = baseUrlApis.getBaseUrl();

    if (domainForDeveloper.indexOf(redirectUrl) > -1) {
      const devConfig = oneDriveConfig.dev

      this.CLIENT_ID = devConfig.CLIENT_ID  // appstore@foxitsoftware.com (个人账号 -> Owned applications -> Foxit PDF Editor Dev)
    }
    if (domainForDeploy.indexOf(redirectUrl) > -1) {
      const proConfig = oneDriveConfig.pro

      this.CLIENT_ID = proConfig.CLIENT_ID  // appstore@foxitsoftware.com (个人账号 -> Applications from personal account)
    }
  },
  AUTHORIZATION_URL: function () {
    let redirectUrl = baseUrlApis.getBaseUrl();
    const language = store.appStore.lng.full;

    return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${this.CLIENT_ID}&scope=${encodeURIComponent(
      'user.read Files.ReadWrite.All',
    )}&response_type=token&prompt=login&redirect_uri=${redirectUrl}OneDriveAuthrizationWin.html&mkt=${language}`;
  },
};

export const DROP_BOX_API = {
  BASEURL: 'https://api.dropboxapi.com',
  CONTENT_URL: 'https://content.dropboxapi.com',
  GET_FILES: '/2/files/list_folder',
  GET_USER_INFO: '/2/users/get_current_account',
  DOWNLOAD_FILE: '/2/files/download',
  REVOKE_ACCESS_TOKEN: '/2/auth/token/revoke',
  CREATE_FILE: '/2/files/upload',
  CREATE_FOLDER: '/2/files/create_folder_v2',
};
export const DROP_BOX_CONFIG = {
  CLIENT_ID: '',
  AUTHORIZATION_URL: function () {
    let redirectUrl = baseUrlApis.getBaseUrl();
    const language = store.appStore.lng.full;

    if (domainForDeveloper.indexOf(redirectUrl) > -1) {
      const devConfig = dropBoxConfig.dev
      
      this.CLIENT_ID = devConfig.CLIENT_ID
    }
    if (domainForDeploy.indexOf(redirectUrl) > -1) {
      const proConfig = dropBoxConfig.pro

      this.CLIENT_ID = proConfig.CLIENT_ID
    }

    return `https://www.dropbox.com/oauth2/authorize?locale=${language}&response_type=token&client_id=${this.CLIENT_ID}&force_reauthentication=true&redirect_uri=${redirectUrl}DropBoxAuthrizationWin.html`;
  },
};

export const BOX_API = {
  UPLOAD_BASEURL: 'https://upload.box.com',
  BASEURL: 'https://api.box.com',
  GET_ACCESS_TOKEN: '/oauth2/token',
  GET_USER_INFO: '/2.0/users/me',
  GET_FILES: '/2.0/folders',
  GET_ROOT_FILES: '/2.0/folders/0/items',
  DOWNLOAD_FILE: '/2.0/files',
  REVOKE_ACCESS_TOKEN: '/oauth2/revoke',
  UPDATE_FILE: '/api/box/updateFile',
  UPLOAD_FILE: '/api/box/uploadFile',
  CREATE_FOLDER: '/2.0/folders',
};
export const BOX_CONFIG = {
  CLIENT_ID: '',
  CLIENT_SECRET: '',
  AUTHORIZATION_URL: function () {
    let redirectUrl = baseUrlApis.getBaseUrl();

    if (domainForDeveloper.indexOf(redirectUrl) > -1) {
      const devConfig = boxConfig.dev

      this.CLIENT_ID = devConfig.CLIENT_ID
      this.CLIENT_SECRET = devConfig.CLIENT_SECRET
    }
    if (domainForDeploy.indexOf(redirectUrl) > -1) {
      const proConfig = boxConfig.pro

      this.CLIENT_ID = proConfig.CLIENT_ID
      this.CLIENT_SECRET = proConfig.CLIENT_SECRET
    }

    return `https://account.box.com/api/oauth2/authorize?response_type=code&client_id=${this.CLIENT_ID}&redirect_uri=${redirectUrl}BoxAuthrizationWin.html`;
  },
};

export const SUPPORT_FILE_MIME_TYPES = [
  'application/vnd.google-apps.spreadsheet',
  'application/vnd.google-apps.presentation',
  'application/vnd.google-apps.document',
  'text/html',
  'text/csv',
  'text/plain',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroenabled.12',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  'application/vnd.ms-excel.template.macroenabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint.template.macroenabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-powerpoint',
  'application/vnd.ms-visio.viewer',
  // 'application/vnd.ms-xpsdocument',
  'application/vnd.ms-word.template.macroenabled.12',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroenabled.12',
  'application/vnd.ms-powerpoint.presentation.macroenabled.12',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'image/jpg',
  'image/jpeg',
  'image/bmp',
  'image/png',
  'image/gif',
  'image/tiff',
  'image/jpx',
  'image/tif',
  'application/octet-stream',
  'application/rtf'
];
// export const SUPPORT_FILE_EXTENSIONS = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'txt', 'jpg', 'jpeg', 'bmp', 'png', 'gif', 'tiff', 'jpx', 'tif', 'pdf'];
// 修改云编辑值支持，office, 图片，pdf格式打开。
export const SUPPORT_FILE_EXTENSIONS = [
  'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx','jpg', 'jpeg', 'bmp', 'png', 'gif', 'tiff', 'jpx', 'tif', 'pdf'
]
// export const SUPPORT_FILE_EXTENSIONS = [
//   'txt',
//   'text',
//   'xls',
//   'xlt',
//   'xlsx',
//   'xltx',
//   'xlsm',
//   'xlsb',
//   'xltm',
//   'csv',
//   // 'xps',
//   'hwp',
//   'wps',
//   'pdf',
//   'htm',
//   'html',
//   'shtml',
//   'bmp',
//   'DIB',
//   'jpg',
//   'jpeg',
//   'jpe',
//   'gif',
//   'tif',
//   'tiff',
//   'png',
//   'vsd',
//   'vsdx',
//   'ppt',
//   'pptx',
//   'pot',
//   'potx',
//   'pptm',
//   'ppsx',
//   'ppsm',
//   'potm',
//   'doc',
//   'rtf',
//   'docx',
//   'dot',
//   'dotx',
//   'docm',
//   'dotm',
//   'wpd',
// ];
export const SUPPORT_FILE_EXTENSIONS_MAP = {
  AllFiles: [],
  Excel: ['xls', 'xlt', 'xlsx', 'xltx', 'xlsm', 'xlsb', 'xltm', 'csv'],
  Word: ['doc', 'rtf', 'docx', 'dot', 'dotx' ,'docm', 'dotm', 'wpd'],
  PPT: ['ppt', 'pptx', 'pot', 'potx', 'pptm', 'ppsx', 'ppsm', 'potm'],
  Visio: ['vsd', 'vsdx'],
  TXT: ['txt', 'text'],
  ImageFiles: ['bmp', 'DIB', 'jpg', 'jpeg', 'jpe', 'gif', 'tif', 'tiff', 'png'],
  Html: ['htm', 'html', 'shtml'],
  PDF: ['pdf'],
  WPS: ['wps'],
  HanWord: ['hwp'],
  Gdoc: ['gdoc'],
  Gsheet: ['gsheet'],
  Gslides: ['gslides']
  // XPS: ['xps'],
}
export function isValidFileName(fileName) {
  const fileExtension = fileName.split('.').pop(); // Extract the file extension

  // Convert the file extension to lowercase to make the comparison case-insensitive
  const lowercaseExtension = fileExtension.toLowerCase();

  // Check if the lowercaseExtension exists in the SUPPORT_FILE_EXTENSIONS array
  return SUPPORT_FILE_EXTENSIONS.includes(lowercaseExtension);
}

export function getFileNameWithExtension(name, mimeType) {
  // if (SUPPORT_FILE_TYPES.indexOf(item.name.replace(/.+\./,""))) {
  const fileExtension = name.replace(/.+\./, '');

  if (name.indexOf('.') > -1 && SUPPORT_FILE_EXTENSIONS.indexOf(fileExtension) > -1) {
    return name;
  } else {
    return getFileNameAndExtensionByMIMEType(name, mimeType);
  }
}
export function getFileNameAndExtensionByMIMEType(name, mimeType) {
  let result = '';
  let fileType = mimeType.split('/')[1];

  switch (fileType) {
    case 'msword':
      result = 'doc';
      break;
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
      result = 'docx';
      break;
    case 'vnd.ms-powerpoint':
      result = 'ppt';
      break;
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
      result = 'pptx';
      break;
    case 'vnd.ms-excel':
      result = 'xls';
      break;
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      result = 'xlsx';
      break;
    case 'plain':
      result = 'txt';
      break;
    case 'gif':
      result = 'gif';
      break;
    case 'bmp':
      result = 'bmp';
      break;
    case 'jpg':
      result = 'jpg';
      break;
    case 'jpeg':
      result = 'jpeg';
      break;
    case 'png':
      result = 'png';
      break;
    case 'tiff':
      result = 'tiff';
      break;
    case 'jpx':
      result = 'jpx';
      break;
    case 'tif':
      result = 'tif';
      break;
    case 'pdf':
      result = 'pdf'
      break
    default:
      break;
  }

  return `${name}.${result}`;
}
export const GOOGLE_EXCLUSIVE_MIME_TYPE = [
  'application/vnd.google-apps.spreadsheet',
  'application/vnd.google-apps.presentation',
  'application/vnd.google-apps.document',
]
export let driveNameTokenNameMap = {
  [GOOGLE_DRIVE]: 'GoogleDriveAccessToken',
  [ONE_DRIVE]: 'OneDriveAccessToken',
  [BOX]: 'BoxAccessToken',
  [DROP_BOX]: 'DropBoxAccessToken',
}
export function setDriveTokenInfo(driveName, userAccount) {
  let driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'driveTokenInfo'))
  const accessToken = storageGetItem(localStorage, driveNameTokenNameMap[driveName]);

  if (!driveTokenInfo) {
    let allDriveTokenInfo = {
      [ONE_DRIVE]: [],
      [BOX]: [],
      [DROP_BOX]: [],
      [GOOGLE_DRIVE]: []
    }

    allDriveTokenInfo = {
      ...allDriveTokenInfo,
      [driveName]: [{
        userAccount: userAccount,
        accessToken,
      }]
    }

    storageSetItem(localStorage, 'driveTokenInfo', JSON.stringify(allDriveTokenInfo))
    driveTokenInfo = JSON.parse(storageGetItem(localStorage, 'driveTokenInfo'))
  }

  if(driveTokenInfo[driveName] == undefined){
    driveTokenInfo[driveName]=[]
  }
  if(!driveTokenInfo[driveName].length){
    driveTokenInfo[driveName].push({
      userAccount: userAccount,
      accessToken,
    })

    storageSetItem(localStorage, 'driveTokenInfo', JSON.stringify(driveTokenInfo))

    return
  }


  storageSetItem(localStorage, 'driveTokenInfo', JSON.stringify(driveTokenInfo))

  const isRecorded = driveTokenInfo[driveName].some((item) => {
    if (item.userAccount === userAccount) {
      item.accessToken = accessToken

      return true
    }
  });

  if (!isRecorded) {
    driveTokenInfo[driveName].push({
      userAccount: userAccount,
      accessToken,
    })
  }

  storageSetItem(localStorage, 'driveTokenInfo', JSON.stringify(driveTokenInfo))
}
